// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1lkUl","tab":"Tabs_tab__Zhfqv","tabActive":"Tabs_tabActive__1gAEk"};